import { render, staticRenderFns } from "./cardDetails.vue?vue&type=template&id=0080fa90&scoped=true"
import script from "./cardDetails.vue?vue&type=script&lang=js"
export * from "./cardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080fa90",
  null
  
)

export default component.exports